import { render, staticRenderFns } from "./ExternalPaymentsCard.vue?vue&type=template&id=bc254122&"
import script from "./ExternalPaymentsCard.vue?vue&type=script&lang=js&"
export * from "./ExternalPaymentsCard.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPaymentsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports